export const TEXT = 0;
export const LIST = 1;
export const CHECKBOX = 2;
export const DATE = 3;
export const TIME = 4;
export const TIMEZONE = 6;
export const TAGS = 7;
export const DYNAMIC = 8;
export const LINK = 9;
export const COLOR = 10;
export const LDAP = 11;
export const MULTILIST = 12;
export const IP = 13;
export const CALC = 14;
export const HASH = 15;
export const EMAIL = 16;
export const URL = 17;
export const FILENAME = 18;
export const USER = 19;
export const NUMERIC = 20;
export const TIMEINTERVAL = 21;
export const TEXTAREA = 22;
export const DESCRIPTION = 23;
export const PASSWORD = 24;
export const INVOLVEDINCIDENTS = 25;
export const RADIO = 26;
export const IPDOMAIN = 27;
export const DOMAIN = 28;

const fields = {
    TEXT,
    LIST,
    CHECKBOX,
    DATE,
    TIME,
    TIMEZONE,
    TAGS,
    DYNAMIC,
    LINK,
    COLOR,
    LDAP,
    MULTILIST,
    IP,
    CALC,
    HASH,
    EMAIL,
    URL,
    FILENAME,
    USER,
    NUMERIC,
    TIMEINTERVAL,
    TEXTAREA,
    DESCRIPTION,
    PASSWORD,
    INVOLVEDINCIDENTS,
    RADIO,
    IPDOMAIN,
    DOMAIN
};

export default fields;

/*
0: "TEXT"
1: "LIST"
2: "CHECKBOX"
3: "DATE"
4: "TIME"
6: "TIMEZONE"
7: "TAGS"
8: "DYNAMIC"
9: "LINK"
10: "COLOR"
11: "LDAP"
12: "MULTILIST"
13: "IP"
14: "CALC"
15: "HASH"
16: "EMAIL"
17: "URL"
18: "FILENAME"
19: "USER"
20: "NUMERIC"
21: "TIMEINTERVAL"
22: "TEXTAREA"
23: "DESCRIPTION"
24: "PASSWORD"
25: "INVOLVEDINCIDENTS"
26: "RADIO"
27: "IPDOMAIN"
28: "DOMAIN"
*/

export const customFieldsNumbers = fields;

export const customFieldsLiterals = (types => {
    const literals = [];
    for (const [key, value] of Object.entries(types)) {
        literals[value] = key;
    }
    return literals;
})(fields);

export const humanReadableName = {
    0: 'text',
    1: 'list',
    2: 'checkbox',
    3: 'date',
    4: 'date & time', // TIME
    6: 'timezone',
    7: 'tags',
    8: 'dynamic',
    9: 'link',
    10: 'color',
    11: 'ldap',
    12: 'multi select list', // MULTILIST
    13: 'ip',
    14: 'calculation', // CALC
    15: 'hash',
    16: 'e-mail address', // EMAIL
    17: 'url',
    18: 'filename',
    19: 'user details',
    20: 'numeric',
    21: 'time interval', // TIMEINTERVAL
    22: 'textarea',
    23: 'description',
    24: 'password',
    25: 'involved incidents', // INVOLVEDINCIDENTS
    26: 'radio',
    27: 'ip or domain', // IPDOMAIN
    28: 'domain'
};

export const namedTypes = {
    text: 0,
    list: 1,
    checkbox: 2,
    date: 3,
    datetime: 4,
    'date & time': 4,
    timezone: 6,
    tag: 7,
    tags: 7,
    dynamic: 8,
    link: 9,
    color: 10,
    ldap: 11,
    multilist: 12,
    'multi select list': 12,
    ipaddress: 13,
    ip: 13,
    calculation: 14,
    sha256: 15,
    md5: 15,
    sha1: 15,
    hash: 15,
    'e-mail': 16,
    'e-mail address': 16,
    url: 17,
    domain: 28,
    ip_domain: 27,
    filename: 18,
    'user details': 19,
    port: 20,
    integer: 0,
    numeric: 20,
    number: 20,
    'time interval': 21,
    textarea: 22,
    description: 23,
    password: 24,
    'involved incidents': 25,
    radio: 26,
    fileDetonate: 'fileDetonate'
};
